// Semantic status color for a match / coverage percentage, using the theme's
// status palette (success/warning/error — see RootLayout) rather than raw
// Mantine names. Shared by every surface that shows a "% match" so the
// thresholds stay in one place.
export const matchColor = (pct: number): string =>
    pct >= 70 ? 'success' : pct >= 50 ? 'warning' : 'error'
